module.exports = __webpack_public_path__ + "media/images/application/icons/socials/icon-twitter-7c0eeed7f8c001e78028c089ead49cf5.svg";